import React from 'react';
import PropTypes from 'prop-types';

const Giphy = ({slug, width, ratio}) => {
  const src = `https://giphy.com/embed/${slug}`;

  return (
    <iframe
      src={src}
      title={`Giphy ${slug}`}
      width={width}
      height={width / ratio}
      frameBorder="0"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowFullScreen
    />
  );
};

Giphy.propTypes = {
  slug: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
};

export default Giphy;
